import React, { useContext, useState, useEffect } from "react";
import { SidebarWrapper } from "./style";
import icon1 from "../../images/dashBoardIcon.svg";
import icon2 from "../../images/myacountIcon.svg";
import icon3 from "../../images/supportIcon.svg";
import icon4 from "../../images/document.svg";
import icon5 from "../../images/logoutIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ContextDashboard from "../../Context/ContextDashboard";
import { getStorage } from "../../Utils/common";

// Define allowed mobile numbers
const ALLOWED_MOBILES = ["7700000803", "7404880600"];

function SideBar({ toggle, setToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, setps } = useContext(ContextDashboard);

  // Get the base link list
  const getLinkList = () => {
    const baseLinks = [
      {
        link: "/my-dashboard/",
        icon: icon1,
        title: "Dashboard",
      },
      {
        link: "/my-dashboard/profile-preview",
        icon: icon2,
        title: "My Account",
      },
    ];

    const userMobile = getStorage("mobile") || getStorage("user_mobile") || "";
    console.log("User mobile from storage:", userMobile);
    const isAuthorized = ALLOWED_MOBILES.includes(userMobile);
    console.log("Is authorized:", isAuthorized);

    // Only add CIBIL Request if authorized
    if (isAuthorized) {
      baseLinks.push({
        link: "/my-dashboard/bureau-request",
        icon: icon2,
        title: "Bureau Score",
      });
    }

    baseLinks.push(
      {
        link: "/contact",
        icon: icon3,
        title: "Support",
      },
      {
        link: "/my-dashboard/leads",
        icon: icon1,
        title: "Loan History",
      },
      {
        link: "/termsandconditions",
        icon: icon4,
        title: "Terms and Conditions",
      },
      {
        link: "/privacypolicy",
        icon: icon4,
        title: "Privacy Policy",
      }
    );

    return baseLinks;
  };

  const linkList = getLinkList();

  const redirect = (link) => {
    if (link === "/my-dashboard/") {
      if (getStorage("eligibility") === 1) {
        link = "/my-dashboard/eligibility";
      }
    }

    if (link === "/my-dashboard/profile-preview") {
      if (getStorage("eligibility") === 1) {
        link = "/my-dashboard/lead-preview";
      }
    }

    if (link === "") {
      link = "/my-dashboard/";
    }

    if (window.innerWidth < 768) {
      setToggle(true);
    }

    navigate(link);
  };

  return (
    <SidebarWrapper className={toggle ? "close" : ""}>
      <ul style={{ marginTop: 18 }}>
        {linkList.map((value, index) => {
          return (
            <li
              key={index}
              onClick={() => redirect(value.link)}
              className={
                location.pathname === value.link ? "active pointer" : "pointer"
              }
            >
              <div>
                <img src={value.icon} alt="" />
              </div>
              <span>{value.title}</span>
            </li>
          );
        })}
        <li onClick={logout}>
          <div>
            <img src={icon5} alt="" />
          </div>
          <span>Logout</span>
        </li>
      </ul>
    </SidebarWrapper>
  );
}

export default SideBar;